export class Token {
  accessToken: string;
  expires: string;
  isValidToken: boolean;
}
